'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

import { cartService } from '@/services';
import Icon from './Icon';

type CartToolsProps = {};

const getLocalItemCount = () => {
  try {
    return cartService.getLocalCartItems().reduce((total, order) => total + (order.quantity || 0), 0);
  } catch (_) {
    return 0;
  }
};

const CartTools = ({}: CartToolsProps) => {
  const router = useRouter();
  const [itemCount, setItemCount] = useState(0);

  useEffect(() => {
    setItemCount(getLocalItemCount());
    const handler = () => setItemCount(getLocalItemCount());
    window.addEventListener('cart:updated', handler);
    return () => window.removeEventListener('cart:updated', handler);
  }, []);

  const handleCartClick = () => {
    router.push('/cart');
  };

  return (
    <div className="relative">
      <button type="button" onClick={handleCartClick} data-testid="cart-button" className="flex items-center justify-center text-gray-700 hover:text-gray-400 cursor-pointer" title="Ver carrito">
        <Icon name="cart" size={20} />
        {itemCount > 0 && (
          <span data-testid="cart-badge" className="absolute -top-2 -right-2 bg-primary text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">{itemCount > 99 ? '99+' : itemCount}</span>
        )}
      </button>
    </div>
  );
};

export default CartTools;
